import React, { useState, useEffect } from 'react';

const Pregunta = ({ pregunta, responder, mostrandoRespuestaCorrecta, respuestaSeleccionada }) => {
  const [seleccionada, setSeleccionada] = useState(null);

  useEffect(() => {
    setSeleccionada(null);
  }, [pregunta]);

  const handleSeleccion = (opcion) => {
    if (!mostrandoRespuestaCorrecta) {
      setSeleccionada(opcion);
    }
  };

  const getClaseBoton = (opcion) => {
    if (mostrandoRespuestaCorrecta) {
      if (opcion === pregunta.respuestaCorrecta) {
        return 'respuesta-correcta';
      }
      if (opcion === respuestaSeleccionada) {
        return 'seleccionada';
      }
    } else if (opcion === seleccionada) {
      return 'seleccionada';
    }
    return '';
  };

  return (
    <div>
      <div className="pregunta-container">
        <h3>{pregunta.pregunta}</h3>
      </div>
      <div className="button-container">
        {pregunta.opciones.map((opcion, index) => (
          <button
            key={index}
            onClick={() => handleSeleccion(opcion)}
            className={getClaseBoton(opcion)}
            disabled={mostrandoRespuestaCorrecta}
          >
            {opcion}
          </button>
        ))}
      </div>
      <button
        onClick={() => responder(seleccionada)}
        disabled={!seleccionada || mostrandoRespuestaCorrecta}
        className="boton-responder"
      >
        Responder
      </button>
    </div>
  );
};

export default Pregunta;
